import { Divider, useTheme } from "@mui/material";
import React, { CSSProperties, FunctionComponent } from "react";

export const PiperDivider: FunctionComponent<IPiperDividerProps> = ({ variant, style, color }) => {
  const theme = useTheme();
  return (
    <Divider
      variant={variant}
      style={style}
      sx={{
        borderColor: color ?? theme.palette.colors?.divider,
        borderWidth: "1px"
      }}
    />
  );
};

interface IPiperDividerProps {
  variant?: "fullWidth" | "inset" | "middle";
  style?: CSSProperties;
  color?: string;
}
